import { lang } from '@umu/ukit-lang';
/**
 * @description 树的搜索框
 */
import React, { createRef, useState } from 'react';
import { If } from 'common/src/components';
import { Iconfont as IconFont, Iconfont } from '@umu/umu-design';

import './departmentSearch.scss';

interface IProps {
    placeholder?: string;
    btnType?: string; // "link" | "text" | "default" | "primary" | "primary-blue" | "ghost" | "ghost-blue" | "ghost-grey" | "text-grey" | "dark-mode"
    searchKeyword?: string;
    searchCallback?(keywords: string): void;
}
export const DepartmentSearch = (props: IProps) => {
    const { btnType = 'primary', placeholder = lang('搜索') } = props;
    const [keywords, setkeywords] = useState(props.searchKeyword || '');
    const searchInputRef: any = createRef();
    const searchInputKeywordRef: any = createRef();
    const setParentCallback = (value: string) => {
        if (props.searchCallback) {
            props.searchCallback(value);
        }
    };
    const onChange = () => {
        const value = searchInputKeywordRef.current!.value;
        setkeywords(value);
    };
    const onKeyUp = (e: React.KeyboardEvent) => {
        switch (e.keyCode) {
            case 13:
                setParentCallback(keywords);
                break;
            default:
                break;
        }
    };
    const onClearBtnClick = () => {
        setkeywords('');
        setParentCallback('');
    };
    return (
        <div className="task-assign-department-header-search-input" ref={searchInputRef}>
            <div className="search-input-box">
                <input
                    type="text"
                    ref={searchInputKeywordRef}
                    className="search-input-keyword"
                    placeholder={placeholder}
                    maxLength={100}
                    onChange={onChange}
                    onKeyUp={onKeyUp as any}
                    value={keywords}
                />
                <If condition={!!keywords}>
                    <IconFont type="Delete2" className="icon-member-clear" onClick={onClearBtnClick} />
                </If>
            </div>
            <div className={`search-button search-button-${btnType}`} onClick={() => setParentCallback(keywords)}>
                <Iconfont className="icon-search" type="search" />
            </div>
        </div>
    );
};
